export default "__VITE_ASSET__DoSzJ5HK__"